export const PRODUCT_LIST_READY = "product-list:ready";
export const PRODUCT_LIST_EMPTY = "product-list:empty";
export const PRODUCT_LIST_WARNING = "product-list:warning";
export const PRODUCT_LIST_ERROR = "product-list:error";
